import { cx } from './cx';

export interface SkeletonProps {
  lines?: number;
  className?: string;
}

export const Skeleton = ({ lines = 3, className = '' }: SkeletonProps) => (
  <div className={cx('space-y-2', className)} aria-hidden="true">
    {Array.from({ length: lines }, (_, i) => (
      <div
        key={i}
        className="h-3 animate-pulse rounded-sm bg-sage-200"
        style={i === lines - 1 && lines > 1 ? { width: '70%' } : undefined}
      />
    ))}
  </div>
);
